import { WEb_SOCKET_URL } from '../../constants/constant';

export default function clientInitFun() {
  window._socket = new WebSocket(WEb_SOCKET_URL);
  window._socket.onopen = () => {
    console.log('Socket 已打开');
  };
  window._socket.onclose = () => {
    console.log('Socket已关闭');
  };
  window._socket.onerror = a => {
    console.log('Socket发生了错误');
  };
  window._socket.onmessage = (msg: any) => {
    console.log('onmessage', msg, msg?.data);
  };
  window.onbeforeunload = () => {
    window._socket.close();
  };
}
